import { render, staticRenderFns } from "./ModalBillingOrder.vue?vue&type=template&id=c6a4062c"
import script from "./ModalBillingOrder.vue?vue&type=script&lang=js"
export * from "./ModalBillingOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports